interface IErrorNotificationProps {
  error?: Error;
}
export const ErrorNotification = ({ error }: IErrorNotificationProps) => {
  return !error ? null : (
    <div className="notification is-danger has-text-weight-bold">{error}</div>
  );
};
